// src/pages/mallkiosk/DietaryScreen.js
// Shown after language selection, before stall selection. Skippable.
import React, { useState } from 'react';
import DietaryTiles from '../../components/DietaryTiles';

export default function DietaryScreen({ mall, isAr, initial = 'none', onContinue, onSkip }) {
  const [pref, setPref] = useState(initial || 'none');

  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 40,
      direction: isAr ? 'rtl' : 'ltr',
    }}>
      <div style={{ fontSize: 20, color: 'var(--text2)', marginBottom: 8 }}>{mall?.name}</div>
      <div style={{ fontSize: 42, fontWeight: 800, color: 'var(--text)', textAlign: 'center' }}>
        {isAr ? 'هل لديك تفضيلات غذائية؟' : 'Any dietary preferences?'}
      </div>
      <div style={{ fontSize: 20, color: 'var(--text2)', margin: '10px 0 40px', textAlign: 'center' }}>
        {isAr ? 'سنعرض لك الخيارات المناسبة' : "We'll highlight the right options for you"}
      </div>

      <div style={{ width: '100%', maxWidth: 1000 }}>
        <DietaryTiles large value={pref} onChange={setPref} isAr={isAr} />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 36, marginTop: 44 }}>
        <button type="button" onClick={onSkip} style={{
          background: 'none', border: 'none', color: 'var(--text2)', fontSize: 20, textDecoration: 'underline', cursor: 'pointer',
        }}>{isAr ? 'تخطي' : 'Skip'}</button>
        <button type="button" onClick={() => onContinue(pref)} style={{
          padding: '22px 64px', fontSize: 26, fontWeight: 800, borderRadius: 20,
          background: 'var(--accent)', color: 'var(--button-text)', border: 'none', cursor: 'pointer',
        }}>{isAr ? 'متابعة ←' : 'Continue →'}</button>
      </div>
    </div>
  );
}
